import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Icon,
  Input,
  Segment
} from 'semantic-ui-react';
import LineItem from '_views/lineItem';

const APITokenItem = ({
  onRegenerateToken,
  onRemoveToken,
  token
}) => {

  const [copied, setCopied] = useState(false);

  const onCopy = (jwt) => {
    navigator.clipboard.writeText(jwt).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Segment
      as={ Grid }
      basic
      stackable
      celled
    >
      <Grid.Row verticalAlign='middle'>
        <Grid.Column width={ 4 } >
          <LineItem label='Id' text={ token._id } />
          <LineItem label='Name' text={ token.name } />
          <LineItem label='Created on' text={ moment(token.updated_on).format('YYYY-MM-DD, HH:mm') } />
        </Grid.Column>
        <Grid.Column width={ 10 } >
          <Input
            action={
              token.jwt && token.jwt.length ? {
                labelPosition: 'right',
                icon: 'copy',
                color: 'blue',
                content: copied ? 'Copied!' : 'Copy',
                onClick: () => onCopy(token.jwt)
              } : {
                labelPosition: 'right',
                icon: 'refresh',
                content: 'Regenerate',
                onClick: () => onRegenerateToken(token)
              }
            }
            value={ token.jwt && token.jwt.length ? token.jwt : '**********************' }
            fluid
            readOnly
          />
        </Grid.Column>
        <Grid.Column width={ 2 }>
          <Button onClick={ () => onRemoveToken(token) } fluid negative >
            <Icon name='trash' />
            Remove
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Segment>
  );
}

APITokenItem.propTypes = {
  onRegenerateToken: PropTypes.func.isRequired,
  onRemoveToken: PropTypes.func.isRequired,
  token: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    created_on: PropTypes.string.isRequired,
    jwt: PropTypes.string,
    name: PropTypes.string.isRequired,
    updated_on: PropTypes.string.isRequired
  }).isRequired
};

export default APITokenItem;



// WEBPACK FOOTER //
// ./webAdmin/components/apitokens/token.js